export default "__VITE_ASSET__Aj_53yfU__"